import React, { useEffect } from 'react';
import { Switch, Route, Redirect, useParams, useHistory, useRouteMatch } from 'react-router-dom';

import { useCourseContext } from '@ts-core/context/course';

import courseRoutes from 'modules/courses/routes';

import { useAcademyAuthUtils } from 'modules/auth/hooks';
import { useCourse } from '../../hooks';

const CourseDashboardPage = () => {
  const history = useHistory();
  const { path } = useRouteMatch();

  const { setCourse } = useCourseContext();

  const { courseId } = useParams();
  const { course } = useCourse({ courseId });

  const { academyHasFeatures } = useAcademyAuthUtils();

  useEffect(() => {
    setCourse(course);
  }, [course, setCourse]);

  if (!courseId) {
    history.replace('/courses');
    return null;
  }

  return (
    <Switch>
      {courseRoutes
        .filter((route) => academyHasFeatures(route.requiredFeatures))
        .map((route, index) => (
          <Route key={index} path={`${path}${route.path}`} component={route.component} exact={route.exact} />
        ))}
      <Redirect to="/courses" />
    </Switch>
  );
};

export default CourseDashboardPage;
